"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Bag = function Bag(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.991 5.124c-.547 0-.991-.407-.991-.91 0-.501.444-.908.991-.908h18.018c.547 0 .991.407.991.909s-.444.909-.991.909H.991zm17.027 13.058V4.592l-3.023-2.774h-9.99L1.982 4.591v13.59h16.036zM19.009 20H.991C.444 20 0 19.593 0 19.09V4.216c0-.241.104-.472.29-.643L3.894.266c.186-.17.438-.266.7-.266h10.811c.263 0 .515.096.701.266l3.604 3.306c.186.17.29.402.29.643V19.09c0 .502-.444.909-.991.909zM13.514 8.347c0-.502.443-.909.99-.909.548 0 .991.407.991.91 0 2.815-2.425 5.04-5.495 5.04-3.07 0-5.495-2.225-5.495-5.04 0-.503.443-.91.99-.91.548 0 .991.407.991.91 0 1.811 1.539 3.222 3.514 3.222 1.975 0 3.514-1.41 3.514-3.223z",
    id: "bag"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#bag"
  }));
};

var _default = Bag;
exports["default"] = _default;
module.exports = exports["default"];